import { apiFetch } from '../lib/apiFetch';

type SignedUrlKey = 'thumbnailUrl' | 'downloadUrl';

export async function resolveSignedHalUrl(
  href: string,
  urlKey: SignedUrlKey,
): Promise<string | null> {
  const response = await apiFetch(href);
  if (!response.ok) {
    return null;
  }
  const data = await response.json();
  const url = data[urlKey];
  return typeof url === 'string' ? url : null;
}
